import { DataTable } from "@/components/datatable/datatable"
import { DataTableSupabase } from "@/components/datatable/supadatatable"
import { Page, PageTitle } from "@/components/page"
import { useDatabaseData, usePage } from "@/components/page/hooks"
import { Button } from "@/components/ui/button"
import { supabase } from "@/lib/data"
import { Copy, Plus, Trash2 } from "lucide-react"
import { usePermissions } from "@/lib/hooks/usePermissions"
import { CRUDLoader } from "@/components/page/crudloader"


const columns: Columns<Evaluation_Category> = {
  id: { header: "ID", size: 100 },
  name: { header: "Name", size: 300 },
  description: { header: "Description", size: 400 },
  created_at: { header: "Created", cell: DataTable.cellRender.date, size: 166 },
}

export function Eval_Categories() {

  const { navigate, team } = usePage()
  const { canCreate, canDelete } = usePermissions()
  const { data: teams, loading } = useDatabaseData("teams")

  async function copyToTeam(v: Evaluation_Category, team: Team) {
    console.log(v)
    console.log(team)
    if (!v || !team) return


    let { data, error } = await supabase.from("eval_items").select().eq("category", v.id)
    if (!data || data.length == 0) return

    const classifCopy: Evaluation_Category = { ...v }

    delete classifCopy.id
    classifCopy.team = team.id

    const { data: dbClassif } = await supabase.from("eval_categories").insert(classifCopy).select().single()

    if (!dbClassif) return

    const evalItems = data.map(item => {
      delete item.id
      item.category = dbClassif.id
      item.team = team.id
      return item
    })

    await supabase.from("eval_items").insert(evalItems as any)

  }

  const menu: DropdownMenuContents = [
    ...(canDelete("classifications") ? [
      {
        title: "Delete",
        icon: <Trash2 />,
        ask: "Are you sure you want to delete this evaluation category?",
        action: async (v: Evaluation_Category) => {
          await supabase.from("eval_categories").delete().eq("id", v.id)
        },
      },
      {
        title: "Copy to Team",
        items: teams.filter(t => t.id != team?.id).map(team => ({
          title: team.name,
          ask: `Are you sure you want to copy this classification and items to '${team.name}'?`,
          action: async (v: Evaluation_Category) => {
            await copyToTeam(v, team)
          },
        })),
      },
    ] : []),
  ]

  if (loading) return <CRUDLoader />


  return <Page>
    <div className="h-full grid grid-rows-[auto_1fr] gap-4">
      <div className="flex">
        <PageTitle />
        <div className="grow"></div>
        {canCreate("classifications") && <div>
          <Button className="rounded-lg" onClick={() => navigate('/evaluations/evalcats/new')}><Plus className="h-4 w-4" />New Category</Button>
        </div>}
      </div>
      <DataTableSupabase
        table="eval_categories"
        columns={columns}
        showSelection
        onRowClick={"/evaluations/evalcats"}
        sort={["created_at", "desc"]}
        filter={q => q.eq("team", team?.id)}
        actions={menu.length > 0 ? menu : undefined}
        enableServerSideFiltering={true}
        searchableColumns={["name", "applies_to", "description"]}
      />
    </div>
  </Page>

}
